export default "/images/log-out.svg?3d243e9f40434c5add5a1dc09b528bdf";